import { useEffect, useRef } from "react";
import { useInView } from "react-intersection-observer";
import { useEventTracking } from "@b2bportal/core-tracking";
import type { RoomInfoProducts } from "@b2bportal/lodging-api";
import {
  HotelsRawEventName,
  useEmitCoreHotelsRawEvent,
} from "../../../../../tracking";

type UseHotelRoomCardTrackingParams = {
  room: RoomInfoProducts;
  threshold?: number[];
};

export const useHotelRoomCardTracking = ({
  room,
  // By default, emit the event when 50% of the card becomes visible
  threshold = [0.5],
}: UseHotelRoomCardTrackingParams) => {
  const { ref, inView } = useInView({ threshold });
  const emitCardInView = useEmitCoreHotelsRawEvent(
    HotelsRawEventName.HotelViewedRoomInList
  );

  const { getAllAttributes } = useEventTracking();

  const indexInList = Number(getAllAttributes()["indexInList"]);

  const emitCardInViewRef = useRef(emitCardInView);
  emitCardInViewRef.current = emitCardInView;

  useEffect(() => {
    if (inView && indexInList != null && room != null) {
      emitCardInViewRef.current({
        properties: {
          room_id: room.roomInfo.roomId,
          room_index_in_shop: indexInList,
          room_media_count: room.roomInfo.media.length,
          selectable_rates_count: room.products.length,
        },
      });
    }
  }, [inView, room, indexInList]);

  return { ref };
};
